import myTheme from "common/theme";

export default theme => ({
    ...myTheme,
    ...{}
});